import React from 'react';
import { Clock } from 'lucide-react';
export function StickyUrgencyBar() {
  return <div className="sticky top-0 bg-urgency text-white py-2.5 px-4 text-center text-xs md:text-sm font-sans font-medium z-50 flex items-center justify-center gap-2 shadow-md" data-id="element-309">
      <span className="relative flex h-2 w-2 shrink-0" data-id="element-310">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" data-id="element-311"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-white" data-id="element-312"></span>
      </span>
      <Clock size={14} className="shrink-0" data-id="element-313" />
      <p data-id="element-314">
        <span className="font-bold" data-id="element-315">⚡ Oferta por tiempo limitado</span>
        <span className="hidden sm:inline" data-id="element-316">
          {' '}
          · Accede a EL CÓDIGO DEL CIERRE™ con TODOS los bonos por solo{' '}
        </span>
        <span className="sm:hidden" data-id="element-317"> · Solo </span>
        <span className="font-extrabold" data-id="element-318">$6.99 USD</span>
      </p>
    </div>;
}